export default "__VITE_ASSET__cIuED1i$__"